module.exports = __webpack_public_path__ + "static/media/hubspot.ec229b39.svg";